import { Box, Button, Card, CardContent, CardHeader, Tooltip, Typography } from '@material-ui/core';
import { amber, blue, deepOrange, orange, pink, red, teal, yellow } from '@material-ui/core/colors';
import { EmojiEmotions, SentimentDissatisfiedRounded, SentimentSatisfiedRounded, SentimentVeryDissatisfiedRounded, SentimentVerySatisfiedRounded } from '@material-ui/icons';
import { size } from 'lodash';
import React, { Component } from 'react';
import { MiniPaper } from '../../../commonModules/layouts/CardPage';
import { calcData } from '../PaygChart';

class CreditScore extends Component {
    state = {  }
    calcScore = () => {
        const {userInfo, paymentList, abo} = this.props;
        let data = calcData(userInfo, paymentList, abo)

        let payments = data[4]
        let previsions = data[5]

        console.log('==============START calc================');
        console.log({data, payments, previsions });
        console.log('====================================');
        let sizePay = size(payments)
        let sizePrev = size(previsions)
        if (sizePay > sizePrev) {
            for (let index = sizePrev; index < sizePay; index++) {
                payments[sizePrev - 1] += payments[index]
            }
            payments.length = sizePrev
            console.log('===============ERROR====sizePay > sizePrev================');
            console.log({payments, previsions });
            console.log('====================================');
            
        } else if (sizePay < sizePrev){
            for (let index = sizePrev - 1; index < sizePay; index++) {
                payments.push(0)
            }
            console.log('===============ERROR====sizePay < sizePrev================');
            console.log({payments, previsions });
            console.log('====================================');
        }
        // if (sizePay !== sizePrev) {
        //     return 0
        // }
        let nb_periodes = sizePrev
        let score = 0
        
        for (let index = 0; index < nb_periodes; index++) {
            
            let res = payments[index] / previsions[index]
            if (res > 2) {
                res = 2
            }
            score += res
        }
        let scorePer = score / nb_periodes * 100
        console.log('====================================');
        console.log({score, nb_periodes, sizePay, sizePrev});
        console.log('====================================');
        return {score : (Math.round(score * 100)/ 100), nb_periodes, scorePer : (Math.round(scorePer * 100)/ 100)}
    }
    render() {
        let score = this.calcScore()
        let emoji = <EmojiEmotions fontSize="large" style={{ color: 'white'}} />
        let color = "white"
        if (score.scorePer < 25) {
            emoji = <SentimentVeryDissatisfiedRounded fontSize="large" style={{ color: 'white'}} />
            color = red[300]
        } else if (score.scorePer < 50) {
            emoji = <SentimentDissatisfiedRounded fontSize="large" style={{ color: 'white'}} />
            color = deepOrange[300]
        } else if (score.scorePer < 75) {
            emoji = <SentimentSatisfiedRounded fontSize="large" style={{ color: 'white'}} />
            color = amber[300]
        } else {
            emoji = <SentimentVerySatisfiedRounded fontSize="large" style={{ color: 'white'}} />
            color = teal[400]
        }

        return (
            <Tooltip
                placement="right"
                arrow
                title={`Score ${score.score}/${score.nb_periodes} paiements`}
            >
                <Card style={{
                    borderRadius: "90px", 
                    height: "90px", 
                    width: "90px", 
                    textAlign: "center", 
                    display: "flex", 
                    flexDirection:"column", 
                    justifyContent: "space-evenly",
                    backgroundColor: color,
                    color:"white",
                    fontWeight: "900"
                }}
                >
                    {/* <CardHeader
                        title="Credit score"
                        avatar={emoji}
                        action={`${Math.round(score * 100)/ 100} %`}
                    />
                    <CardContent style={{paddingTop: 0, textAlign: "right"}}>
                        {Math.round(score * 100)/ 100} %
                    </CardContent> */}
                    <Box>{emoji}</Box>
                    <Box><Typography variant="body1" >{score.scorePer} %</Typography></Box>
                </Card>
            </Tooltip>
        );
    }
}

export default CreditScore;